import {
  CloseOutlined,
  DownOutlined,
  ShoppingCartOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { calculateGrandTotal } from "../../modules/calculateGrandTotal";
import { calculateTotalRooms } from "../../modules/calculateTotalRooms";
import { formatCurrency } from "../../modules/formatCurrency";
import { getDragStyleByDevices } from "../../modules/getDragStyleByDevices";

export const BookingSidebarHeader = (props) => {
  const {
    isMobile,
    branding,
    currency,
    convertAmount,
    isMinimized,
    toggleMinimizeSidebar,
    fromdate,
    todate,
    handleCloseSidebar,
    bookingSidebar,
    extraBedPrice,
    totaldays,
  } = props;
  const { t } = useTranslation();
  return (
    <div
      className="drag-handle justify-content-between"
      style={{
        ...getDragStyleByDevices({ isMobile, branding }),
      }}
    >
      {isMobile ? (
        <>
          <div
            className="justify-content-between"
            style={{
              width: "100%",
            }}
          >
            <div className="flex-direction-column">
              <p
                style={{
                  marginTop: "2px",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                <strong>
                  {moment(fromdate, "DD-MM-YYYY").format("DD MMM")} -{" "}
                  {moment(todate, "DD-MM-YYYY").format("DD MMM")}
                </strong>
              </p>
              <p className="mt-2" style={{ margin: "0", fontSize: "13px" }}>
                <strong>
                  {t("homescreen.total_nights")}: {totaldays}
                </strong>
              </p>
            </div>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <p
                style={{
                  marginRight: "30px",
                  fontSize: "18px",
                  fontWeight: "bold",
                  marginTop: "7px",
                }}
              >
                {formatCurrency(
                  calculateGrandTotal({
                    bookingSidebar,
                    extraBedPrice,
                    totaldays,
                  }),
                  currency,
                  convertAmount
                )}
              </p>
            </div>
          </div>
        </>
      ) : (
        <span style={{ color: "white", marginLeft: "10px" }}>
          <strong>{t("homescreen.your_bookings")}</strong>
        </span>
      )}
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShoppingCartOutlined style={{ color: "white", marginLeft: "10px" }} />
        <span style={{ color: "white", marginRight: "5px" }}>
          {calculateTotalRooms(bookingSidebar)}
        </span>
        <Button
          type="text"
          icon={isMinimized ? <DownOutlined /> : <UpOutlined />}
          onClick={toggleMinimizeSidebar}
          className="no-drag"
          style={{
            color: "white",
            padding: "5px",
          }}
        />
        <CloseOutlined
          onClick={handleCloseSidebar}
          className="no-drag"
          style={{
            marginLeft: "10px",
            marginRight: "10px",
            color: "white",
            cursor: "pointer",
          }}
        />
      </div>
    </div>
  );
};
